/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, IconButton, Chip, FormControl, Checkbox, FormHelperText, Grid } from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import SearchNotFound from '../../../SearchNotFound';
import services from '../Service';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types'
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@mui/material/styles';
import xlsx from 'json-as-xlsx';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import { date } from 'faker/lib/locales/az';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

var screenCode = "UNCOMPLETEDPRODUCTLISTREPORT"

export default function UncompletedProductListView(props) {
    const componentRef = useRef();
    const navigate = useNavigate();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Uncompleted Product List Report'
    });

    const [group, setGroup] = useState([]);
    const [datevalue, setDateValue] = useState(new Date());
    const [productcatogery, setProductcatogery] = useState([]);
    const [product, setProduct] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [isHidden, setIsHidden] = useState(false);
    const [uncompletedProductListDetails, setUncompletedProductListDetails] = useState([]);
    const [isEnable, setIsEnable] = useState(true);
    const [grnData, setgrnData] = useState({
        grnName: ''
    });
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);

    const [formData, setFormData] = useState({
        groupID: 0,
        date: datevalue,
        groupName: ""
       
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
       groupName: group.groupName,
        date: formData.date ? new Date(formData.date).toISOString().split('T')[0] : null,
    });

    
    const [selectedOptions, setSelectedOptions] = useState([]);
    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    
    const classes = useStyles();

    const grnSummaryReportSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        date: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
    });


    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            date: formData.date,
            
        },

        validationSchema: grnSummaryReportSchema,
        onSubmit: () => {
            trackPromise(SubmitForm());
            setIsEnable(true);
        }
    });


    async function SubmitForm(values) {
        
        var res = await services.GetUncompletedProductListReportDetails((datevalue).toISOString(),)
        setUncompletedProductListDetails(res.data);
        getSelectedDropdownValuesForReport();
        
        
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        
            setDateValue([]);
            
       
    }

    function getSelectedDropdownValuesForReport() {
        var grpname
        {
            group.map((x) => (
                x.groupID == formik.values.groupID ? grpname = x.groupName : null
            ))
        }


    }


    useEffect(() => {
        setUncompletedProductListDetails([]);
    }, [formik.values.date])

    useEffect(() => {
        setUncompletedProductListDetails([]);
    }, [datevalue]);


    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);




    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - (Array.isArray(uncompletedProductListDetails) ? uncompletedProductListDetails.length : 0)) : 0;


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWUNCOMPLETEDPRODUCTLISTREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        })
        trackPromise(GetAllGroups());
    }    

    async function createFile() {
        var file = await createDataForExcel(uncompletedProductListDetails);
        var settings = {
            sheetName: 'Uncompleted Product Details',
            fileName: 'Uncmpleted Product Details',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Uncompleted Product Details',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    async function createDataForExcel(array) {
        var res = [];

        if (array != null) {
           
            array.forEach(x => {
                var vr = {
                    'ProductCode': x.productCode !== null && x.productCode !== 0 ? x.productCode : '-',
                    'ProductName': x.productName !== null && x.productName !== 0 ? x.productName : '-',
                    'ProductCategoryName': x.productCategoryName !== null && x.productCategoryName !== 0 ? x.productCategoryName : '-',
                };
                res.push(vr);
            });

            res.push({}); 

            var groupNameRow = {
                'ProductCode': 'Group Name',
                'ProductName': selectedSearchValues.groupName !== null && selectedSearchValues.groupName !== 0 ? selectedSearchValues.groupName : '-',
                'ProductCategoryName': ''
            };
            res.push(groupNameRow);

            var dateRow = {
                'ProductCode': 'Date',
                'ProductName': selectedSearchValues.date !== null && selectedSearchValues.date !== 0 ? selectedSearchValues.date : '-',
                'ProductCategoryName': ''
            };
            res.push(dateRow);
        }

        return res;
    }


    function getSelectedDropdownValuesForReport() {
        let groups = group.find(x => x.groupID == formik.values.groupID);

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: groups ? groups.groupName : '-',
            date: new Date(datevalue).toISOString().split('T')[0]
        });
    }




    return (
        <>
            <LoadingComponent />
            <Page title="Uncompleted Product List Report  |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Grid item md={4} xs={12} >
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Group *"
                                                value={formik.values.groupID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('groupID')}
                                                error={Boolean(touched.groupID && errors.groupID)}
                                                helperText={touched.groupID && errors.groupID}
                                                InputProps={{
                                                    readOnly: !permissionList.isGroupFilterEnabled
                                                }}
                                            >
                                                <MenuItem key={0} value={0}>Select Group</MenuItem>
                                                {group.map((option) => (
                                                    option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                        {option.groupName}
                                                    </MenuItem> : null
                                                ))}
                                            </TextField>
                                        </Grid>
                                        <Grid item md={4} xs={12} >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    label="Select Date"
                                                    value={datevalue}
                                                    onChange={(newValue) => {
                                                        setDateValue(newValue);
                                                    }}
                                                    maxDate={new Date()} 
                                                    renderInput={(params) => <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...getFieldProps('date')}
                                                        error={Boolean(touched.date && errors.date)}
                                                        helperText={touched.date && errors.date}
                                                        {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </Grid>  
                                    </Stack>
                                    <div>
                                        <br />
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button type="button" variant="outlined" color="error"
                                                onClick={() => clearAll()}
                                            >
                                                Clear
                                            </Button>
                                            <Button type="submit" color="secondary" variant="outlined">
                                                Search
                                            </Button>
                                        </Stack>
                                    </div>
                                </Stack>
                                <br />
                                {isEnable == false ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginBottom: '10px' }} justifyContent="right" spacing={2}>
                                        <TextField
                                            size="small"
                                            style={{ width: '300px' }}
                                            value={grnData.grnName}
                                            placeholder="Search"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Search />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Stack> : null}
                                {Array.isArray(uncompletedProductListDetails) && uncompletedProductListDetails.length != 0 ?
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Card style={{ justifyContent: 'center', width: '85rem' }}>
                                            <TableContainer component={Paper}>
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center">ProductCode</TableCell>
                                                            <TableCell align="center">ProductName</TableCell>
                                                            <TableCell align="center">ProductCategoryName</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(rowsPerPage > 0
                                                            ? uncompletedProductListDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            : uncompletedProductListDetails
                                                        ).map((row) => (
                                                            <TableRow key={row.productCode}>
                                                                <TableCell align="center">
                                                                    {row.productCode !== null ? row.productCode : '-'}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.productName !== null ? row.productName : '-'}
                                                                </TableCell>
                                                                <TableCell align="center">
                                                                    {row.productCategoryName !== null ? row.productCategoryName : '-'}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        {emptyRows > 0 && (
                                                            <TableRow style={{ height: 53 * emptyRows }}>
                                                                <TableCell colSpan={6} />
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                    <TableFooter>
                                                        <TableRow>
                                                            <TablePagination
                                                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                                colSpan={6}
                                                                count={uncompletedProductListDetails.length}
                                                                rowsPerPage={rowsPerPage}
                                                                page={page}
                                                                SelectProps={{
                                                                    inputProps: {
                                                                        'aria-label': 'rows per page',
                                                                    },
                                                                    native: true,
                                                                }}
                                                                onPageChange={handleChangePage}
                                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                                ActionsComponent={TablePaginationActions}
                                                            />
                                                        </TableRow>
                                                    </TableFooter>
                                                </Table>
                                            </TableContainer>
                                        </Card>
                                    </Stack> : <SearchNotFound searchQuery="Uncompleted Product  Details" />}
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {uncompletedProductListDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Uncompleted Product List Report Details"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    uncompletedProductListDetails={uncompletedProductListDetails}
                                    searchData={selectedSearchValues}
                                />
                            </div>
                        </Box>
                        : null}
                </Container>
            </Page>
        </>
    );

}
